import { useQuery } from '@tanstack/react-query';
import { Select } from 'antd';
import { type DefaultOptionType } from 'antd/es/select';
import { getPayrollTypeDropdown } from 'src/apis/master_data/payrollType.api';

type Props = {
  value?: number | undefined;
  style?: React.CSSProperties | undefined;
  onChange?: ((value: number, option: DefaultOptionType | DefaultOptionType[]) => void) | undefined;
  allowClear?: boolean | undefined;
  placeholder?: React.ReactNode;
  className?: string;
};

export default function PayrollTypeSelect({
  value,
  style,
  allowClear = true,
  onChange,
  placeholder,
  className
}: Props) {
  const payrollTypeDropdownQuery = useQuery({
    queryKey: ['payrollTypeDropdown'],
    queryFn: () => getPayrollTypeDropdown(),
    staleTime: 60 * 1000 * 5
  });

  return (
    <Select
      allowClear={allowClear}
      value={payrollTypeDropdownQuery.isFetching ? undefined : value}
      style={style}
      className={className}
      placeholder={placeholder}
      onChange={onChange}
      options={payrollTypeDropdownQuery.data?.data.map((data) => ({
        value: data.id,
        label: data.name
      }))}
      showSearch
      filterOption={(input, option) => (option?.label?.toString() ?? '').toLowerCase()?.includes(input.toLowerCase())}
      loading={payrollTypeDropdownQuery.isFetching}
    />
  );
}
